/* eslint-disable max-len */
function replaceAll(data, search, replacement) {
  const target = data;
  return target.replace(new RegExp(search, 'g'), replacement);
}
function trimChars(data, c) {
  const re = new RegExp(`^[${c}]+|[${c}]+$`, 'g');
  return data.replace(re, '');
}
function formatText(text) {
  return replaceAll(text.trim().toUpperCase(), ' ', '_');
}
function formatLocation(location) {
  let path = '';
  if (location && location.pathname) {
    const locations = location.pathname.split('/');
    if (locations.length > 1) path = locations[1].toUpperCase();
  }
  if (path) return `${path}_`;
  return '';
}
function getActionText(e) {
  let text = '';
  const regexAlphaNumeric = /^[a-zA-Z0-9 ]*$/;
  if (e.target.innerText) {
    if (regexAlphaNumeric.test(e.target.innerText)) return trimChars(`_${e.target.innerText}`, '_');
  }
  if (e.target && e.target.firstChild && e.target.firstChild.classList && e.target.firstChild.classList.value) text += `_${e.target.firstChild.classList.value}`;
  if (e.target && e.target.classList && e.target.classList.value) text += `_${e.target.classList.value}`;
  return trimChars(text, '_');
}
function getParentActionText(e) {
  let text = '';
  const regexAlphaNumeric = /^[a-zA-Z0-9 ]*$/;
  if (e.target.parentElement && e.target.parentElement.innerText) {
    if (regexAlphaNumeric.test(e.target.parentElement.innerText)) return trimChars(`_${e.target.parentElement.innerText}`, '_');
  }
  if (e.target && e.target.classList && e.target.classList.value) text += `_${e.target.classList.value}`;
  if (e.target && e.target.parentElement && e.target.parentElement.classList && e.target.parentElement.classList.value) text += `_${e.target.parentElement.classList.value}`;
  return trimChars(text, '_');
}
function createEventAction(e) {
  let classValue = '';
  let parentClassValue = '';
  if (e.target && e.target.classList && e.target.classList.value) classValue = e.target.classList.value;
  if (e.target && e.target.parentElement && e.target.parentElement.classList && e.target.parentElement.classList.value) parentClassValue = e.target.parentElement.classList.value;
  // booking & unit tab status
  if (parentClassValue && parentClassValue.includes('tab-status')) {
    return `TAB_STATUS_${formatText(
      parentClassValue.replace('tab-status', '')
      .replace('center', '')
      .replace('aligned', '')
      .replace('column', '')
      .replace('selected', ''))}`;
  }
  if (classValue && classValue.includes('tab-status')) {
    return `TAB_STATUS_${formatText(
      classValue.replace('tab-status', '')
      .replace('center', '')
      .replace('aligned', '')
      .replace('column', '')
      .replace('selected', ''))}`;
  }
  // a link
  if (e.target.tagName === 'A' && !(parentClassValue && parentClassValue.includes('button')) && !(classValue && (classValue.includes('button') || (classValue.includes('top-menu') && classValue.includes('item'))))) {
    if (getActionText(event)) return `A_${formatText(getActionText(event))}`;
  }
  // icon
  if (e.target.tagName === 'I' && classValue.includes('icon') && !(parentClassValue && parentClassValue.includes('button'))) {
    if (formatText(classValue)) return `ICON_${formatText(classValue)}`;
  }
  // input
  if (e.target.tagName.includes('INPUT') && e.target.placeholder) {
    if (formatText(e.target.placeholder)) return `INPUT_${formatText(e.target.placeholder)}`;
  }
  // label
  if (e.target.tagName.includes('LABEL') && e.target.innerText) {
    if (parentClassValue && parentClassValue.includes('checkbox') && formatText(e.target.innerText)) return `CHECKBOX_${formatText(e.target.innerText)}`;
    if (formatText(e.target.innerText)) return `LABEL_${formatText(e.target.innerText)}`;
  }
  // dropdown
  if (parentClassValue && parentClassValue.includes('dropdown')) {
    if (getParentActionText(event)) return `DROPDOWN_${formatText(getParentActionText(event))}`;
  }
  if (classValue && (classValue.includes('dropdown') ||
    (classValue.includes('item') && !(classValue.includes('top-menu')) && parentClassValue && parentClassValue.includes('dropdown')))
  ) {
    if (getActionText(event)) return `DROPDOWN_${formatText(getActionText(event))}`;
  }
  // item
  if (parentClassValue && parentClassValue.includes('item')) {
    if (getParentActionText(event)) return `ITEM_${formatText(getParentActionText(event))}`;
  }
  if (classValue && (classValue.includes('dropdown') || (classValue.includes('item') && !(classValue.includes('top-menu'))))) {
    if (getActionText(event)) return `DROPDOWN_${formatText(getActionText(event))}`;
  }
  // image
  if (parentClassValue && parentClassValue.includes('image')) {
    if (getParentActionText(event)) return `IMAGE_${formatText(getParentActionText(event))}`;
  }
  if (classValue && classValue.includes('image')) {
    if (getActionText(event)) return `IMAGE_${formatText(getActionText(event))}`;
  }
  if (e.target.tagName.includes('IMG')) {
    if (getActionText(event)) return `IMAGE_${formatText(getActionText(event))}`;
  }
  // button
  if (parentClassValue && parentClassValue.includes('button')) {
    if (getParentActionText(event)) return `BUTTON_${formatText(getParentActionText(event))}`;
  }
  if (classValue && classValue.includes('button')) {
    if (getActionText(event)) return `BUTTON_${formatText(getActionText(event))}`;
  }
  if (e.target.tagName.includes('BUTTON')) {
    if (getActionText(event)) return `BUTTON_${formatText(getActionText(event))}`;
  }
  return '';
}
export function gaClickEventAction(e) {
  if (createEventAction(e)) return formatLocation(window.location) + createEventAction(e);
  return null;
}
export function gaClickEventLabel(e) {
  return `_X${e.screenX}Y${e.screenY}W${window.screen.width}H${window.screen.height}`;
}



// WEBPACK FOOTER //
// ./src/utils/gaEvents.js